import React, { ReactNode } from 'react';
import { Swiper } from 'swiper/react';
import { A11y, Navigation, Pagination } from 'swiper';
import { isMobile } from '@/helpers/browser';
import ButtonArrow from '@/components/button/ButtonArrow/ButtonArrow';
import PaginateContainer from '@/components/carrousel/PaginateContainer/PaginateContainer';
import { navigationOption, paginationOption as defaultPaginationOptions } from '@/lib/swiperConfig';
import { CarrouselWrapper } from './CarrouselFeatured.styles';
import PaginateContainerDynamic from '@/components/carrousel/PaginateContainer/PaginateContainerDynamic';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';

export interface CarrouselFeaturedProps {
  slidesPerView?: number;
  minHeight?: string;
  /**A list of SwiperSlide children*/
  children?: ReactNode;
  paginationOptions?: Pick<typeof defaultPaginationOptions, 'clickable' | 'dynamicBullets'>;
}

const CarrouselFeatured = ({ paginationOptions, children, ...props }: CarrouselFeaturedProps) => {
  const mobile = isMobile();

  return (
    <CarrouselWrapper {...props}>
      <Swiper
        breakpoints={{
          0: {
            slidesPerView: 1,
            spaceBetween: 16,
          },
          576: {
            slidesPerView: 2,
            spaceBetween: 32,
          },
          992: {
            slidesPerView: props.slidesPerView,
            spaceBetween: 32,
          },
        }}
        pagination={paginationOptions ? { ...paginationOptions, el: `.pagination-dynamic` } : defaultPaginationOptions}
        navigation={navigationOption(mobile)}
        modules={[A11y, Pagination, Navigation]}
      >
        {children}
        {(paginationOptions && (
          <PaginateContainerDynamic className="pagination-dynamic swiper-pagination-clickable swiper-pagination-bullets-dynamic swiper-pagination-bullets swiper-pagination-horizontal" />
        )) || <PaginateContainer className="paginate-container" />}
      </Swiper>
      <ButtonArrow mobile={false} appearence="circle" direction="left" className="carrousel-prev" />
      <ButtonArrow mobile={false} appearence="circle" direction="right" className="carrousel-next" />
    </CarrouselWrapper>
  );
};

export default CarrouselFeatured;
